import { defineStyleConfig } from "@chakra-ui/react";

const Checkbox = defineStyleConfig({
  // defaultProps: {
  //   colorScheme: "gray",
  // },
});

export default Checkbox;
